{
  "venueEdit": {
    "insertFailure": "No se pudo crear el lugar",
    "editFailure": "No se pudo editar el lugar",
    "deleteFailure": "No se pudo eliminar el lugar",
    "creationSuccess": "El lugar se creó correctamente",
    "editSuccess": "El lugar se cambió correctamente",
    "deleteSuccess": "El lugar se ha eliminado correctamente",
    "topLevel": "Nivel superior"
  },
  "resetZoom": "Restablecer el zoom",
  "shareOrExport": {
    "title": "Comparte/exporta la programación",
    "shareLinkOptionTitle": "Compartir enlace",
    "shareLinkOptionDescription": "Comparte el programa seleccionado mediante un enlace de solo lectura (caduca a los 7 días)",
    "exportOptionTitle": "Exportar el calendario",
    "exportOptionDescription": "Exportar el cronograma seleccionado",
    "shareLinkLabel": "Enlace",
    "exportStarted": "La exportación ha comenzado",
    "pickOption": "Seleccione una opción"
  },
  "eventBlocksImport": "La importación se ha completado correctamente",
  "shareSchedule": "El enlace de la programación compartida se ha copiado a tu portapapeles",
  "visitSchedule": "Calendario de visitas"
}